<template>
  <div>
    <!-- Modal de Cadastro -->
    <div
      v-if="visible && !showSuccessModal"
      class="modal-overlay"
      @click.self="$emit('close')"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 1rem;">
      <div
        role="dialog"
        aria-describedby="add-user-modal-description"
        aria-labelledby="add-user-modal-title"
        class="modal-dialog add-user-modal"
        @click.stop
        style="pointer-events: auto; max-width: 36rem; width: 90%; max-height: calc(100vh - 2rem); background: white; border-radius: 0.75rem; padding: 0; position: relative; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); display: flex; flex-direction: column; overflow: hidden;">

        <!-- Header (fixo) -->
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 1.5rem 1.5rem 0.5rem 1.5rem; flex-shrink: 0;">
          <div style="display: flex; align-items: center; gap: 0.75rem;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #111827; flex-shrink: 0;">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <line x1="19" x2="19" y1="8" y2="14"></line>
              <line x1="22" x2="16" y1="11" y2="11"></line>
            </svg>
            <div>
              <h2 id="add-user-modal-title" style="font-size: 1.25rem; font-weight: 700; margin: 0; color: #111827;">
                Convidar Novo Usuário
              </h2>
              <p v-if="isWizard" style="font-size: 0.75rem; color: #6b7280; margin: 0.125rem 0 0 0;">
                Etapa {{ step }} de 2 · {{ step === 1 ? 'Dados do usuário' : 'Pagamento' }}
              </p>
            </div>
          </div>
          <button
            type="button"
            style="background: transparent; border: none; cursor: pointer; padding: 0.25rem; display: flex; align-items: center; justify-content: center; color: #6b7280;"
            @click="$emit('close')">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Content (rola; o menu dos dropdowns abre via position:fixed para não ser recortado) -->
        <div style="padding: 1rem 1.5rem 1.5rem 1.5rem; overflow-y: auto; flex: 1 1 auto; min-height: 0;" @scroll.passive="closeAllDropdowns">
          <form ref="inviteForm" autocomplete="off" @submit.prevent="handleInvite">
            <ErrorAlert
              :error="error"
              style="margin-bottom: 1rem; padding: 0.75rem; border-radius: 0.5rem; background-color: #fee2e2; color: #991b1b; border: 1px solid #fecaca;" />

            <!-- PASSO 1: dados do usuário, tipo de acesso, plano e resumo da pró-rata -->
            <template v-if="!isWizard || step === 1">
            <!-- Nome -->
            <div style="margin-bottom: 1rem;">
              <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Nome</label>
              <input
                type="text"
                v-model="form.name"
                placeholder="Nome do usuário"
                required
                style="width: 100%; padding: 0.625rem 0.875rem; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; background-color: #ffffff;"
                :style="{ borderColor: error && !form.name ? '#ef4444' : '#d1d5db' }" />
            </div>

            <!-- Email e Senha (lado a lado, metade cada) -->
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem;">
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Email</label>
                <input
                  type="email"
                  v-model="form.email"
                  placeholder="email@empresa.com"
                  required
                  autocomplete="off"
                  readonly
                  @focus="$event.target.removeAttribute('readonly')"
                  style="width: 100%; padding: 0.625rem 0.875rem; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; background-color: #ffffff; box-sizing: border-box;"
                  :style="{ borderColor: error && !form.email ? '#ef4444' : '#d1d5db' }" />
              </div>
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Senha</label>
                <div style="position: relative;">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="form.password"
                    placeholder="Senha do usuário"
                    required
                    autocomplete="new-password"
                    readonly
                    @focus="$event.target.removeAttribute('readonly')"
                    style="width: 100%; padding: 0.625rem 0.875rem; padding-right: 2.5rem; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; background-color: #ffffff; box-sizing: border-box;"
                    :style="{ borderColor: error && !form.password ? '#ef4444' : '#d1d5db' }" />
                  <button
                    type="button"
                    @click="showPassword = !showPassword"
                    style="position: absolute; right: 0.5rem; top: 50%; transform: translateY(-50%); background: transparent; border: none; cursor: pointer; padding: 0.25rem; color: #6b7280;">
                    <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Tipo de Acesso e Plano (lado a lado quando ilimitado) -->
            <div :style="{ display: 'grid', gridTemplateColumns: isUnlimited ? '1fr 1fr' : '1fr', gap: '1rem', marginBottom: isProRataInvite ? '1rem' : '0.5rem' }">
              <!-- Tipo de Acesso -->
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Tipo de Acesso</label>
                <div class="dropdown" :style="{ position: 'relative', width: '100%', zIndex: showAccessTypeDropdown ? 10001 : 1 }">
                  <button
                    type="button"
                    class="edit-dropdown-button"
                    @click.stop="toggleAccessTypeDropdown"
                    style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0.625rem 0.875rem; background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; cursor: pointer; transition: all 0.2s; position: relative;">
                    <span style="display: flex; align-items: center; gap: 0.5rem;">
                      <svg v-if="form.accessType === 'ADMIN'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                      <span>{{ form.accessType === 'ADMIN' ? 'Administrador' : 'Usuário' }}</span>
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #6b7280;">
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </button>
                  <div
                    v-if="showAccessTypeDropdown"
                    class="dropdown-menu"
                    @click.stop
                    :style="dropdownStyle"
                    style="background: white; border: 1px solid #e5e7eb; border-radius: 0.5rem; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); max-height: 240px; overflow-y: auto;">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="selectAccessType('ADMIN')"
                      style="display: flex; align-items: center; gap: 0.5rem; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                      <span>Administrador</span>
                    </a>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="selectAccessType('USER')"
                      style="display: flex; align-items: center; gap: 0.5rem; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                      <span>Usuário</span>
                    </a>
                  </div>
                </div>
              </div>

              <!-- Plano (apenas quando modelo é ilimitado) -->
              <div v-if="isUnlimited">
                <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Plano</label>
                <div class="dropdown" :style="{ position: 'relative', width: '100%', zIndex: showPlanDropdown ? 10001 : 1 }">
                  <button
                    type="button"
                    class="edit-dropdown-button"
                    @click.stop="togglePlanDropdown"
                    style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0.625rem 0.875rem; background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; cursor: pointer; transition: all 0.2s; position: relative;">
                    <span>
                      <plan-badge
                        v-if="selectedPlanDetails"
                        :plan="selectedPlanDetails.name"
                        :code="form.plan" />
                      <span v-else style="color: #6b7280;">Selecione um plano</span>
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #6b7280;">
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </button>
                  <div
                    v-if="showPlanDropdown"
                    class="dropdown-menu"
                    @click.stop
                    :style="dropdownStyle"
                    style="background: white; border: 1px solid #e5e7eb; border-radius: 0.5rem; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); max-height: 240px; overflow-y: auto;">
                    <a
                      v-for="plan in pricingList"
                      :key="plan.code"
                      class="dropdown-item"
                      href="#"
                      @click.prevent="selectPlan(plan.code)"
                      style="display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                      <plan-badge :plan="plan.name" :code="plan.code" />
                      <span
                        v-if="vacantSeatCount(plan.code) > 0"
                        style="font-size: 0.75rem; font-weight: 600; color: #166534; background-color: #dcfce7; border-radius: 9999px; padding: 0.125rem 0.5rem; white-space: nowrap;">
                        {{ vacantSeatCount(plan.code) }} {{ vacantSeatCount(plan.code) === 1 ? 'livre' : 'livres' }}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Resumo da cobrança pró-rata (plano + proporcional + total) -->
            <pro-rata-summary
              v-if="isProRataInvite && !selectedPlanHasVacantSeat"
              :plan-details="selectedPlanDetails"
              :badge-style="planBadgeStyle"
              :preview="prorataPreview"
              :loading="prorataLoading"
              :error="prorataError" />
            <div
              v-if="selectedPlanHasVacantSeat && selectedPlanDetails"
              style="background-color: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 0.5rem; padding: 0.75rem 1rem;">
              <p style="font-size: 0.875rem; font-weight: 600; color: #166534; margin: 0 0 0.25rem 0;">
                Sem cobrança
              </p>
              <p style="font-size: 0.8125rem; color: #166534; line-height: 1.45; margin: 0;">
                Este usuário vai ocupar uma licença livre do plano {{ selectedPlanDetails.name }}, que já está paga. Ele é ativado assim que você convidar.
              </p>
              <p v-if="selectedPlanVacantSeatExpiry" style="font-size: 0.8125rem; color: #b45309; line-height: 1.45; margin: 0.5rem 0 0 0;">
                A licença livre deste plano expira em {{ formatSeatShortDay(selectedPlanVacantSeatExpiry) }}: o usuário poderá usá-la até {{ formatSeatShortLastUsableDay(selectedPlanVacantSeatExpiry) }} e será desativado nessa data.
              </p>
            </div>
            </template>

            <!-- PASSO 2: forma de pagamento e contato para cobrança -->
            <div v-if="isWizard" v-show="step === 2">
              <payment-method-selector v-model="selectedPaymentMethod" style="margin-bottom: 1.5rem;" />

              <billing-contact-fields
                ref="contactFields"
                style="margin-bottom: 1.25rem;"
                @valid="contactValid = $event" />

              <!-- Aviso do fluxo de ativação/pagamento -->
              <p style="font-size: 0.75rem; color: #6b7280; line-height: 1.45; margin: 0 0 0.25rem 0;">
                Após confirmar, o usuário recebe o e-mail de ativação imediatamente. As funcionalidades são liberadas após o pagamento da cobrança.
              </p>
            </div>

            <!-- Footer -->
            <div style="display: flex; justify-content: flex-end; gap: 0.75rem; padding-top: 1rem;">
              <!-- Secundário: Voltar (passo 2 do wizard) ou Cancelar -->
              <button
                v-if="isWizard && step === 2"
                type="button"
                @click="step = 1"
                :disabled="isSubmitting"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #ffffff; color: #374151; border: 1px solid #e5e7eb; cursor: pointer; transition: all 0.2s;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m15 18-6-6 6-6"></path>
                </svg>
                Voltar
              </button>
              <button
                v-else
                type="button"
                @click="$emit('close')"
                :disabled="isSubmitting"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #ffffff; color: #374151; border: 1px solid #e5e7eb; cursor: pointer; transition: all 0.2s;">
                Cancelar
              </button>

              <!-- Primário: Próximo (passo 1) / Convidar e gerar cobrança (passo 2) / Convidar (recarga) -->
              <button
                v-if="isWizard && step === 1"
                type="button"
                @click="goToStep2"
                :disabled="step1Blocked"
                :style="{ opacity: step1Blocked ? 0.6 : 1, cursor: step1Blocked ? 'not-allowed' : 'pointer' }"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; transition: all 0.2s;">
                <span>Próximo</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m9 18 6-6-6-6"></path>
                </svg>
              </button>
              <button
                v-else-if="isWizard && step === 2"
                type="submit"
                :disabled="isSubmitting || !contactValid"
                :style="{ opacity: (isSubmitting || !contactValid) ? 0.6 : 1, cursor: (isSubmitting || !contactValid) ? 'not-allowed' : 'pointer' }"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; transition: all 0.2s;">
                <svg v-if="!isSubmitting" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <line x1="19" x2="19" y1="8" y2="14"></line>
                  <line x1="22" x2="16" y1="11" y2="11"></line>
                </svg>
                <span v-if="isSubmitting">Gerando cobrança...</span>
                <span v-else>Convidar e gerar cobrança</span>
              </button>
              <button
                v-else
                type="submit"
                :disabled="isSubmitting"
                :style="{ opacity: isSubmitting ? 0.6 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; transition: all 0.2s;">
                <svg v-if="!isSubmitting" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <line x1="19" x2="19" y1="8" y2="14"></line>
                  <line x1="22" x2="16" y1="11" y2="11"></line>
                </svg>
                <span v-if="isSubmitting">Enviando...</span>
                <span v-else>Convidar</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Card de sucesso (convite enviado + link de pagamento quando há cobrança) -->
    <invite-success-card
      :visible="showSuccessModal"
      :email="form.email"
      :payment-link="chargeGeneratedPaymentLink"
      :amount="chargeGeneratedValue"
      :due-date="chargeGeneratedDueDate"
      :vacant-seat-plan="vacantSeatPlan"
      @close="handleCloseSuccess" />
  </div>
</template>

<script>
import axios from 'axios'
import loopback from '@/services/loopback'
import { generateInviteEmailHtml } from '@/utils/emailHtml'
import { getPlanBadgeStyle } from '@/utils/plan-badge'
import { planBenefitLabels } from '../Subscription/pricing-comparison'
import { campaignDiscount } from '../Subscription/plan-showcase'
import { friendlyPlainText, normalizeError } from '@/utils/error-message'
import { billingTypeForPaymentMethod } from '@/utils/billing-type'
import { VACANT_SEAT_PATH, formatSeatShortDay, formatSeatShortLastUsableDay } from '@/utils/seats'
import PlanBadge from './PlanBadge.vue'
import ProRataSummary from './invite/ProRataSummary.vue'
import PaymentMethodSelector from './invite/PaymentMethodSelector.vue'
import BillingContactFields from './invite/BillingContactFields.vue'
import InviteSuccessCard from './invite/InviteSuccessCard.vue'

export default {
  name: 'AddUserModal',
  components: {
    PlanBadge,
    ProRataSummary,
    PaymentMethodSelector,
    BillingContactFields,
    InviteSuccessCard
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isUnlimited: {
      type: Boolean,
      default: false
    },
    pricingList: {
      type: Array,
      default: () => []
    },
    vacantSeatPlanCodes: {
      type: Array,
      default: () => []
    },
    // planCode → expiração, só dos planos em que todas as licenças livres expiram.
    vacantSeatExpiryByPlanCode: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        accessType: 'USER',
        plan: ''
      },
      showPassword: false,
      showAccessTypeDropdown: false,
      showPlanDropdown: false,
      dropdownStyle: {},
      step: 1,
      error: null,
      isSubmitting: false,
      showSuccessModal: false,
      // Forma de pagamento (passo 2) + validade do contato (emitida pelo filho).
      selectedPaymentMethod: 'credit_card',
      contactValid: false,
      // Cobrança gerada (exibida no card de sucesso)
      chargeGeneratedPaymentLink: '',
      chargeGeneratedValue: null,
      chargeGeneratedDueDate: null,
      vacantSeatPlan: '',
      // Preview da pró-rata
      prorataPreview: null,
      prorataLoading: false,
      prorataError: null
    }
  },
  computed: {
    // Plano gratuito (Gerencial): não gera cobrança nem cria seat — convida direto como ACTIVE.
    selectedPlanIsFree () {
      return !!this.selectedPlanDetails && Number(this.selectedPlanDetails.monthlyFee) <= 0
    },
    // Convite com cobrança pró-rata: conta de plano (isUnlimited) com plano pago escolhido.
    isProRataInvite () {
      return this.isUnlimited && !!this.form.plan && !this.selectedPlanIsFree
    },
    // Conta de plano usa fluxo em 2 passos (dados → pagamento). Recarga, plano grátis e
    // plano com licença livre são passo único: não há o que pagar.
    isWizard () {
      return this.isUnlimited && !this.selectedPlanIsFree && !this.selectedPlanHasVacantSeat
    },
    selectedPlanHasVacantSeat () {
      return this.isProRataInvite && this.vacantSeatCount(this.form.plan) > 0
    },
    selectedPlanVacantSeatExpiry () {
      if (!this.selectedPlanHasVacantSeat) return null
      const expiry = this.vacantSeatExpiryByPlanCode[this.form.plan]
      return expiry === undefined ? null : expiry
    },
    // `form.plan` guarda o CÓDIGO do plano. Guardar o nome de exibição casava por título,
    // e dois planos com o mesmo título fariam o cliente escolher um e contratar o outro,
    // em silêncio — o `find` devolveria o primeiro da lista.
    selectedPlanDetails () {
      if (!this.form.plan || this.pricingList.length === 0) return null
      const plan = this.pricingList.find(p => p.code === this.form.plan)
      if (!plan) return null
      const hasBoundedMinutes = plan.minutes != null && plan.minutes > 0
      const minutesLabel = hasBoundedMinutes ? `até ${plan.minutes} min` : null
      return {
        name: plan.name,
        monthlyFee: Number(plan.monthlyFee),
        minutesLabel,
        benefits: planBenefitLabels(plan),
        campaignDiscount: campaignDiscount(plan, Date.now())
      }
    },
    // Cor do plano (mesma do chip PlanBadge): fundo/borda/total do resumo de pró-rata.
    planBadgeStyle () {
      return getPlanBadgeStyle(this.form.plan)
    },
    // Bloqueia o "Próximo" (passo 1) até dados básicos + plano + preview da pró-rata prontos.
    step1Blocked () {
      if (!this.form.name || !this.form.email || !this.form.password || !this.form.plan) return true
      return this.prorataLoading || !!this.prorataError || !this.prorataPreview
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.resetForm()
        this.showSuccessModal = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('resize', this.closeAllDropdowns)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('resize', this.closeAllDropdowns)
  },
  methods: {
    resetForm () {
      this.form = {
        name: '',
        email: '',
        password: '',
        accessType: 'USER',
        plan: ''
      }
      this.showPassword = false
      this.showAccessTypeDropdown = false
      this.showPlanDropdown = false
      this.dropdownStyle = {}
      this.step = 1
      this.error = null
      this.isSubmitting = false
      this.selectedPaymentMethod = 'credit_card'
      this.contactValid = false
      this.chargeGeneratedPaymentLink = ''
      this.chargeGeneratedValue = null
      this.chargeGeneratedDueDate = null
      this.vacantSeatPlan = ''
      this.prorataPreview = null
      this.prorataLoading = false
      this.prorataError = null
    },
    closeAllDropdowns () {
      this.showAccessTypeDropdown = false
      this.showPlanDropdown = false
    },
    toggleAccessTypeDropdown (event) {
      if (event) {
        event.stopPropagation()
      }
      const willOpen = !this.showAccessTypeDropdown
      this.showPlanDropdown = false
      if (willOpen) this.setDropdownPosition(event)
      this.showAccessTypeDropdown = willOpen
    },
    togglePlanDropdown (event) {
      if (event) {
        event.stopPropagation()
      }
      const willOpen = !this.showPlanDropdown
      this.showAccessTypeDropdown = false
      if (willOpen) this.setDropdownPosition(event)
      this.showPlanDropdown = willOpen
    },
    // Posiciona o menu via position:fixed (coordenadas do botão) para ele escapar
    // do scroll do modal sem ser recortado.
    setDropdownPosition (event) {
      const el = event && event.currentTarget
      if (!el || typeof el.getBoundingClientRect !== 'function') {
        this.dropdownStyle = {}
        return
      }
      const rect = el.getBoundingClientRect()
      this.dropdownStyle = {
        position: 'fixed',
        top: `${rect.bottom + 4}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        zIndex: 10001
      }
    },
    selectAccessType (type) {
      this.form.accessType = type
      this.showAccessTypeDropdown = false
    },
    selectPlan (plan) {
      this.form.plan = plan
      this.showPlanDropdown = false
      this.fetchProrataPreview()
    },
    async fetchProrataPreview () {
      this.prorataPreview = null
      this.prorataError = null
      if (!this.isUnlimited || !this.form.plan || this.selectedPlanIsFree) return
      const planCode = this.form.plan
      this.prorataLoading = true
      try {
        // Preview via pbxapi (proxy ao billing) — mesmo cálculo da cobrança real.
        this.prorataPreview = await loopback.get('/users/proration-preview', { params: { planName: planCode } })
      } catch (err) {
        this.prorataError = this.resolveProrataErrorMessage(err)
      } finally {
        this.prorataLoading = false
      }
    },
    resolveProrataErrorMessage (err) {
      // TEL-2243: o `friendly` do interceptor ja resolve por codigo. A versao
      // anterior casava por trecho em ingles e capturava por engano "Seat not
      // found in an active subscription", dizendo ao cliente que a conta nao
      // tinha assinatura quando ela tinha. O fallback cobre `UNKNOWN` e erro
      // sem `friendly`, entao a funcao nunca devolve vazio — o botao de avancar
      // depende dessa string ser falsy so quando nao ha erro.
      return friendlyPlainText(err, 'Não foi possível calcular a cobrança proporcional. Tente novamente.')
    },
    handleClickOutside (event) {
      const modal = event.target.closest('.modal-dialog')
      if (!modal || !this.$el.contains(modal)) {
        return
      }

      const isDropdownButton = event.target.closest('.edit-dropdown-button')
      const isDropdownMenu = event.target.closest('.dropdown-menu')
      const isDropdownItem = event.target.closest('.dropdown-item')
      const isDropdown = event.target.closest('.dropdown')

      if (!isDropdownButton && !isDropdownMenu && !isDropdownItem && !isDropdown) {
        this.closeAllDropdowns()
      }
    },
    // Passo 1 → 2 (wizard): valida os dados básicos + plano + preview antes de avançar.
    goToStep2 () {
      this.error = null
      const required = !this.form.name || !this.form.email || !this.form.password
      if (required || !this.form.plan) {
        this.error = { message: 'Por favor, preencha todos os campos obrigatórios' }
        return
      }
      if (this.prorataLoading || this.prorataError || !this.prorataPreview) return
      this.step = 2
    },
    async handleInvite () {
      this.error = null

      const required = !this.form.name || !this.form.email || !this.form.password
      if (required || (this.isUnlimited && !this.form.plan)) {
        this.error = { message: 'Por favor, preencha todos os campos obrigatórios' }
        return
      }

      // Plano grátis (Gerencial): convida COM plano pelo billing (cria o seat
      // manager, sem cobrança) e ativa direto — sem janela/etapa de pagamento.
      if (this.isUnlimited && this.form.plan && this.selectedPlanIsFree) {
        await this.finalizeFreeInvite()
        return
      }

      if (this.selectedPlanHasVacantSeat) {
        await this.finalizeVacantSeatInvite()
        return
      }

      // Convite sem plano (recarga): cria direto e mostra a confirmação.
      if (!this.isProRataInvite) {
        this.isSubmitting = true
        try {
          const newUser = await loopback.post('/users', {
            name: this.form.name,
            email: this.form.email,
            password: this.form.password,
            role: this.form.accessType,
            emailVerified: false,
            status: 'ACTIVE'
          })
          this.showSuccessModal = true
          this.$emit('user-invited', newUser)
        } catch (err) {
          console.error('Erro ao convidar usuário:', err)
          this.error = { message: this.resolveInviteErrorMessage(err) }
        } finally {
          this.isSubmitting = false
        }
        return
      }

      // Wizard: no passo 1, Enter/submit apenas avança para o pagamento.
      if (this.step === 1) {
        this.goToStep2()
        return
      }

      // Convite de plano (passo 2): gera a cobrança pró-rata com o meio de pagamento escolhido.
      await this.finalizeProRataInvite()
    },
    // Convite de plano GRÁTIS (Gerencial): chama invite-with-plan sem meio de
    // pagamento — o billing cria o seat (manager) sem cobrança e devolve sem
    // paymentUrl. Sem janela de pagamento; o success card mostra "Convite enviado!".
    async finalizeFreeInvite () {
      this.isSubmitting = true
      try {
        const planCode = this.form.plan
        const result = await loopback.post('/users/invite-with-plan', {
          name: this.form.name,
          email: this.form.email,
          password: this.form.password,
          role: this.form.accessType,
          planName: planCode
        })
        const newUser = (result && result.user) || result
        this.chargeGeneratedPaymentLink = ''
        this.chargeGeneratedValue = null
        this.chargeGeneratedDueDate = null
        this.showSuccessModal = true
        this.$emit('user-invited', newUser)
      } catch (err) {
        console.error('Erro ao convidar usuário gratuito:', err)
        this.error = { message: this.resolveInviteErrorMessage(err) }
      } finally {
        this.isSubmitting = false
      }
    },
    // Plano com licença livre: o billing ocupa a licença e não cobra (path VACANT_SEAT).
    // A contagem de livres vem da tela e pode ter envelhecido — se a licença foi
    // ocupada no meio do caminho, a resposta vem PRO_RATA com o link, e o card de
    // sucesso mostra a cobrança em vez de dizer que foi grátis.
    async finalizeVacantSeatInvite () {
      this.isSubmitting = true
      try {
        const result = await loopback.post('/users/invite-with-plan', {
          name: this.form.name,
          email: this.form.email,
          password: this.form.password,
          role: this.form.accessType,
          planName: this.form.plan
        })
        const newUser = (result && result.user) || result
        this.vacantSeatPlan = ''
        this.chargeGeneratedPaymentLink = ''
        this.chargeGeneratedValue = null
        this.chargeGeneratedDueDate = null
        if (result && result.path === VACANT_SEAT_PATH) {
          this.vacantSeatPlan = this.selectedPlanDetails ? this.selectedPlanDetails.name : this.form.plan
        } else if (result) {
          this.chargeGeneratedPaymentLink = result.paymentUrl || result.invoiceUrl || result.externalUrl || ''
          this.chargeGeneratedValue = result.value != null ? result.value : null
          this.chargeGeneratedDueDate = result.dueDate || null
        }
        this.showSuccessModal = true
        this.$emit('user-invited', newUser)
      } catch (err) {
        console.error('Erro ao convidar usuário na licença livre:', err)
        if (normalizeError(err).code === 'INVOICE_BILLING_TYPE_REQUIRED') {
          this.error = { message: 'A licença livre deste plano acabou de ser ocupada. Escolha a forma de pagamento para convidar.' }
          this.$emit('refresh-users')
        } else {
          this.error = { message: this.resolveInviteErrorMessage(err) }
        }
      } finally {
        this.isSubmitting = false
      }
    },
    // 1 POST ao pbxapi (invite-with-plan), que cria o usuário AWAITING_PAYMENT + a
    // cobrança. Antes, persiste os dados financeiros (via BillingContactFields).
    async finalizeProRataInvite () {
      this.isSubmitting = true

      // Abre a janela de pagamento de forma síncrona (antes de qualquer await) para
      // não ser bloqueada por popup blocker.
      const paymentWindow = window.open('', '_blank')
      let paymentWindowUsed = false

      try {
        const contact = this.$refs.contactFields
        const ok = contact ? await contact.persist() : true
        if (!ok) return

        const billingType = billingTypeForPaymentMethod(this.selectedPaymentMethod)
        const planCode = this.form.plan

        const result = await loopback.post('/users/invite-with-plan', {
          name: this.form.name,
          email: this.form.email,
          password: this.form.password,
          role: this.form.accessType,
          planName: planCode,
          billingType
        })

        const newUser = (result && result.user) || result
        this.chargeGeneratedPaymentLink = (result && (result.paymentUrl || result.invoiceUrl || result.externalUrl)) || ''
        this.chargeGeneratedValue = (result && result.value != null) ? result.value : null
        this.chargeGeneratedDueDate = (result && result.dueDate) || null
        this.vacantSeatPlan = result.path === VACANT_SEAT_PATH ? this.selectedPlanDetails.name : ''

        this.showSuccessModal = true
        this.$emit('user-invited', newUser)

        const link = typeof this.chargeGeneratedPaymentLink === 'string' ? this.chargeGeneratedPaymentLink.trim() : ''
        if (link && paymentWindow) {
          paymentWindow.opener = null
          paymentWindow.location.href = link
          paymentWindowUsed = true
        }
      } catch (err) {
        console.error('Erro ao gerar cobrança do convite:', err)
        this.error = { message: this.resolveInviteErrorMessage(err) }
      } finally {
        this.isSubmitting = false
        if (paymentWindow && !paymentWindowUsed) {
          paymentWindow.close()
        }
      }
    },
    formatSeatShortDay,
    formatSeatShortLastUsableDay,
    vacantSeatCount (planCode) {
      if (!planCode) return 0
      return this.vacantSeatPlanCodes.filter(code => code === planCode).length
    },
    resolveInviteErrorMessage (err) {
      if (err && err.details && err.details.codes && err.details.codes.email && err.details.codes.email[0] === 'uniqueness') {
        return 'Email já cadastrado. Por favor, informe outro ou recupere a senha.'
      }
      // TEL-2243: `err.message` e o texto do backend, em ingles — usa o traduzido.
      if (err && err.friendly && Array.isArray(err.friendly.lines) &&
        err.friendly.code !== 'UNKNOWN') {
        return err.friendly.lines.join(' ')
      }
      // TEL-2243: mesmo generico do mapa (utils/error-message.js).
      return 'Não conseguimos processar sua solicitação no momento. Tente novamente em alguns minutos ou fale com o suporte: (48) 3332-8503.'
    },
    triggerInviteWebhook ({ newUser, domain, organizationName }) {
      const webhookUrl = process.env.API4COM_USER_INVITE_WEBHOOK_URL
      if (!webhookUrl) {
        console.warn('api4com > users > invite > webhook URL not configured (API4COM_USER_INVITE_WEBHOOK_URL)')
        return
      }

      const payload = {
        type: 'user_invite',
        organizationName: organizationName || '',
        organizationDomain: domain || '',
        userId: newUser.id,
        userEmail: this.form.email,
        userName: this.form.name,
        accessType: this.form.accessType === 'ADMIN' ? 'Administrador' : 'Usuário',
        // O comercial lê este e-mail: vai o nome de exibição, não o código.
        plan: (this.isUnlimited && this.selectedPlanDetails) ? this.selectedPlanDetails.name : null,
        adminEmail: (this.$store.state.auth.user && this.$store.state.auth.user.email) || null,
        adminPhone: (this.$store.state.auth.user && this.$store.state.auth.user.phone) || null,
        companyName: (this.$store.state.auth.organization && this.$store.state.auth.organization.name) || null,
        tableHtml: ''
      }
      payload.tableHtml = generateInviteEmailHtml(payload)

      return new Promise((resolve) => {
        axios.post(webhookUrl, payload, {
          headers: { 'Content-Type': 'application/json' }
        })
          .then(() => {
            console.log('api4com > users > invite > webhook sent successfully')
            resolve()
          })
          .catch(err => {
            console.error('api4com > users > invite > webhook error', err)
            resolve()
          })
      })
    },
    handleCloseSuccess () {
      this.showSuccessModal = false
      this.$emit('close')
      this.$emit('refresh-users')
    }
  }
}
</script>

<style scoped>
.add-user-modal {
  overflow: hidden !important;
}

.add-user-modal .edit-dropdown-button {
  position: relative;
}

.add-user-modal .edit-dropdown-button:hover {
  border-color: #9ca3af !important;
}

.add-user-modal .edit-dropdown-button:focus {
  outline: none;
  border-color: #2563eb !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.add-user-modal .dropdown {
  position: relative !important;
}

.add-user-modal .dropdown-menu {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.add-user-modal .dropdown-item {
  cursor: pointer;
}

.add-user-modal .dropdown-item:hover {
  background-color: #f9fafb;
}

.modal-overlay {
  animation: fadeIn 0.2s ease-in-out;
}

.modal-overlay .add-user-modal {
  pointer-events: auto;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/AddUserModal.vue